import * as yup from 'yup';
import docs from './attachments';
import {
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDescontoFolha,
  consentimentoDadosSensiveis,
  estaAposentadoINSS,
  foiJulgado,
  houveProcessoJudicial,
  aceiteInss,
  consentimentoAjustePagamento,
  declaracaoVeracidade,
} from './utils/rulesByKey';

export const cpaSchema = yup.object({
  ...estaAposentadoINSS,
  ...houveProcessoJudicial,
  ...foiJulgado(true),
  atividadeRural: yup.string().when('estaAposentadoINSS', {
    is: 'Sim',
    then: yup.string().required('Atenção Selecione a opção Atividade rural'),
  }),
  tempoRuralDias: yup
    .number()
    .max(29, 'Máximo de 29 dias')
    .when('atividadeRural', {
      is: 'Há incidência',
      then: yup.number().required('Atenção, Preencha o campo dias'),
    }),
  tempoRuralMeses: yup
    .number()
    .max(11, 'Máximo de 11 meses')
    .when('atividadeRural', {
      is: 'Há incidência',
      then: yup.number().required('Atenção, Preencha o campo meses'),
    }),
  tempoRuralAnos: yup.number().when('atividadeRural', {
    is: 'Há incidência',
    then: yup.number().required('Atenção, Preencha o campo anos'),
  }),
  ...adiantamentoQuinzenal,
  ...acessoContraCheque,
  // ...acessoJornalForluz,
  ...consentimentoDescontoFolha,
  ...consentimentoDadosSensiveis(),
  ...docs.CPADocs.rules,
  ...aceiteInss,
  ...consentimentoAjustePagamento,
  ...declaracaoVeracidade,
  processoJudicial: yup.number().when('houveProcessoJudicial', {
    is: 'Sim',
    then: yup
      .number()
      .required(
        'Atenção! Preencha o número do processo que originou a aposentadoria.'
      ),
  }),
});

export const CpaInitialValues = {
  estaAposentadoINSS: '',
  houveProcessoJudicial: '',
  processoJudicial: '',
  foiJulgado: '',
  atividadeRural: '',
  tempoRuralDias: '',
  tempoRuralMeses: '',
  tempoRuralAnos: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  aceiteInss: false,
  consentimentoAjustePagamento: false,
  declaracaoVeracidade: false,
  ...docs.CPADocs.initialValues,
};

export const CPADocs = {
  ...docs.CPADocs.docs,
};
